import { IframeApp, TrackMessage } from '../../../../shared/types';
import gtag from '../../../../utils/gtag';

export const FIXED_CW_EVENT_PREFIX = 'dh.app';

const handleTrackingMessage = (message: TrackMessage, app: IframeApp) => {
  const postFix =
    message.payload.params.conversion === true ? '.conversion' : '';

  const prefixedName = `${FIXED_CW_EVENT_PREFIX}.${app.analyticsPrefix}.${message.payload.name}${postFix}`;

  gtag('event', prefixedName, {
    ...message.payload.params,
  });
};

export default handleTrackingMessage;
